import React, { Component } from 'react';
import { array, arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import Button from 'ps-components/Button/Button';
import HeaderData from '../../HeaderData/HeaderData';
import { Tooltip } from 'ps-design';
import './JobMatchingHeader.scss';

class JobMatchingHeader extends Component {
  static propTypes = {
    hideModal: func,
    history: object,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      descriptionDocument: shape({
        fileLocation: string,
        title: string
      }),
      employeeCount: number,
      id: string,
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    updateJobMatches: func,
    tempMatchSelections: array,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    useJobCodeKey: bool
  };

  generateTooltip = () => {
    const { selectedJob } = this.props;

    return (
      <Tooltip
        display="underline"
        hoverText={selectedJob.description}
        id={selectedJob.name}
        position="bottom"
        tooltipText={selectedJob.name}
      />
    );
  };

  submitMatches = () => {
    const { selectedJob, tempMatchSelections } = this.props;
    const old = selectedJob.jobMatches;
    const oldMatchIds = old.map(match => match.surveyJob.id);
    const newMatchIds = tempMatchSelections.map(match => match.surveyJobId);
    const matchesToDelete = [];
    const matchesToAdd = [];
    old.forEach(match => {
      if (!newMatchIds.includes(match.surveyJob.id)) matchesToDelete.push(match.id);
    });

    newMatchIds.forEach((match, index) => {
      if (!oldMatchIds.includes(match)) {
        matchesToAdd.push(tempMatchSelections[index]);
      }
    });
    const jobData = { id: selectedJob.id, code: selectedJob.code, codeKey: selectedJob.codeKey };
    this.props.updateJobMatches(jobData, matchesToAdd, matchesToDelete);
  };

  hideModal = () => {
    const { hideModal, history } = this.props;

    hideModal();
    history.goBack();
  };

  render() {
    const { selectedJob, replacementTokens, useJobCodeKey } = this.props;
    const hasJobDescription = selectedJob.description;
    const hadJobDescriptionDocument = selectedJob.descriptionDocument && selectedJob.descriptionDocument.fileLocation;
    const orgJobCodeKey = replacementTokens.find(value => value.token === 'job_code_key_text');
    const orgJobCodeKeyLabel = orgJobCodeKey && orgJobCodeKey.value ? orgJobCodeKey.value : 'Job Code Key';
    return (
      <div className="header">
        <div className="header-row pxl-text-default">Select Job Matches for</div>
        <div className="header-row header-row__space-between">
          <div className="pxl-header-xsmall details__name">
            {hasJobDescription ? this.generateTooltip() : selectedJob.name}
          </div>
          <div className="header-actions">
            <Button className="matches__btn pxl-btn pxl-btn-primary" onClick={this.submitMatches}>
              Submit Selected Matches
            </Button>
            <span className="matches__modal-close pxl-header-medium" onClick={this.hideModal}>
              <i className="icon-cancel" />
            </span>
          </div>
        </div>
        <div className="header-row header__data-bar">
          <React.Fragment>
            <HeaderData className="pxl-text-muted pxl-text-xsmall" label="Total EE" value={selectedJob.employeeCount} />
            <HeaderData className="pxl-text-muted pxl-text-xsmall" label="Job Code" value={selectedJob.code} />
            {useJobCodeKey && (
              <HeaderData
                className="pxl-text-muted pxl-text-xsmall"
                label={orgJobCodeKeyLabel}
                value={selectedJob.codeKey}
              />
            )}
            <HeaderData className="pxl-text-muted pxl-text-xsmall" label="Currency" value={selectedJob.currency} />
          </React.Fragment>
        </div>
        <div className="header-row details__link-container pxl-text-xsmall">
          {hadJobDescriptionDocument && (
            <a
              className="details__link"
              href={selectedJob.descriptionDocument.fileLocation}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-doc-text" />
              Job description
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default JobMatchingHeader;
